import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { CheckboxField } from '@root/shared/ui-kit'

import type { ExploreFiltersFormModel } from '../../atoms/reatom-explore-filters-form'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  model: ExploreFiltersFormModel
} & ClassNameProps

export const ExploreFilterFormSocials: React.FC<Props> = ({ model }) => {
  const { t } = useTranslation()

  const [withTwitter, setWithTwitter] = useAtom(model.withTwitter)
  const [withTelegram, setWithTelegram] = useAtom(model.withTelegram)
  const [withWebsite, setWithWebsite] = useAtom(model.withWebsite)
  const [withAtLeastOneSocial, setWithAtLeastOneSocial] = useAtom(
    model.withAtLeastOneSocial,
  )

  return (
    <Root>
      <Label>{t('pair.filter.socials')}</Label>
      <AtLeastOneSocial>
        <Field
          checked={withAtLeastOneSocial}
          onCheckedChange={(checked) => {
            if (typeof checked === 'boolean') {
              setWithAtLeastOneSocial(checked)
            }
          }}
          label={t('table.filter.at-least-1-social')}
        />
      </AtLeastOneSocial>

      <CheckboxGroup>
        <Field
          label="X(Twitter)"
          checked={withTwitter}
          onCheckedChange={(checked) => {
            if (typeof checked === 'boolean') {
              setWithTwitter(checked)
            }
          }}
        />
        <Field
          label="Telegram"
          checked={withTelegram}
          onCheckedChange={(checked) => {
            if (typeof checked === 'boolean') {
              setWithTelegram(checked)
            }
          }}
        />
        <Field
          label={t('common.website')}
          checked={withWebsite}
          onCheckedChange={(checked) => {
            if (typeof checked === 'boolean') {
              setWithWebsite(checked)
            }
          }}
        />
      </CheckboxGroup>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 8px;
`

const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  justify-items: start;
`
const AtLeastOneSocial = styled.div`
  display: flex;
`
const Label = styled.label`
  color: var(--text-11);

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;

  margin-bottom: 4px;
`

const Field = styled(CheckboxField)`
  color: var(--text-11);
`
